import React, { HTMLAttributes } from 'react';
import { MuiIconKey } from './types';

interface MuiIconProps extends HTMLAttributes<HTMLSpanElement> {
  icon?: MuiIconKey;
  children?: string;
}
/**
 * Material Icons by Google: https://fonts.google.com/icons?selected=Material+Icons.
 * Find an Icon that you want to display and pass the key in the children prop.
 * @param children string material icon key e.g. info
 * @returns element material icon
 */
export const MuiIcon = ({ children, icon, ...other }: MuiIconProps) => (
  <span className="material-icons" {...other}>
    {icon || children}
  </span>
);

export default MuiIcon;
